import { Checkbox } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { SVG } from "../../../../../../constants/assetLists";
import { AnnouncementFormValues } from "../types";

function TriggerDueNotification() {
  const { control } = useFormContext<AnnouncementFormValues>();

  return (
    <div className="flex items-center gap-4 mb-3">
      <img
        src={SVG.bellFilledBlackIcon}
        alt="icon"
        className="w-[16px] h-[20px] object-contain"
      />

      <Controller
        control={control}
        name="triggerDueNotification"
        render={({ field: { onChange, value } }) => (
          <div className="flex items-center gap-2">
            <Checkbox
              size="medium"
              color="secondary"
              sx={{ p: 0 }}
              checked={!!value}
              onChange={(e) => onChange(e.target.checked)}
            />
            <p className="m-0 text-[16px] text-black">שליחת הודעה בעת תפוגה</p>
          </div>
        )}
      />
    </div>
  );
}

export default TriggerDueNotification;
